angular.module('services.formErrors', [
  'angular-growl'
]).factory('formErrors', ["growl", function (growl) {
  return {
    growlErrors: function (res) {
      if (res.status === 400) {
        if (res.data.name === 'BusinessRuleError') {
          growl.error(res.data.message);
        }
        else{
          _.forIn(res.data.errors, function(error, key) {
            error.messages.forEach(function (message) {
              growl.error(message);
            });
          });
        }
      }
    }
  }
}]);



// WEBPACK FOOTER //
// ./client/src/common/services/formErrors.js